// Service for Attendance Detail
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetAttendanceDetailOut, AttendanceDetail } from '../types';
import { mapAttendanceDetailOutToModel } from '../mappers';


export class AttendanceDetailService {
  async getAttendanceDetail(
    employeeId: number,
    attendanceId: number,
  ): Promise<ApiResponse<AttendanceDetail>> {
    const endpoint = API_CONFIG.ENDPOINTS.ATTENDANCE.GET_ATTENDANCE_DETAIL(
      employeeId,
      attendanceId,
    );

    const response = await apiClient.get<LC_GetAttendanceDetailOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: false,
        data: null,
        error: response.error,
        status: response.status,
      };
    }
    return {
      success: true,
      data: mapAttendanceDetailOutToModel(response.data),
      status: response.status,
    };
  }
}

export const attendanceDetailService = new AttendanceDetailService();
